import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { resolutionAssistantApi } from '@/services/api/entity-resolution-assistant'
import type { MergeExactJob } from '@/services/api/entity-resolution-groups'
import {
  resolutionAssistantJobKey,
  resolutionJobExpired,
  useResolutionInvalidation,
} from './useResolutionAssistant'

/** Both execution and status tools follow the same server job, without another merge action. */
export function useResolutionRuleJob(snapshot: MergeExactJob) {
  const client = useQueryClient()
  const key = resolutionAssistantJobKey(snapshot.case_id, snapshot.job_id)
  const cached = client.getQueryData<MergeExactJob>(key)
  const job = useQuery({
    queryKey: key,
    queryFn: () => resolutionAssistantApi.status(snapshot.case_id, snapshot.job_id),
    initialData: snapshot,
    enabled: snapshot.status === 'running' && (cached?.status ?? 'running') === 'running',
    refetchInterval: query =>
      query.state.data?.status === 'running' && !resolutionJobExpired(query.state.error)
        ? 1500
        : false,
    staleTime: 1000,
    retry: 2,
  })
  useEffect(() => {
    if (snapshot.status !== 'running' && cached?.status === 'running')
      client.setQueryData(key, snapshot)
  }, [client, key, snapshot, cached?.status])
  useResolutionInvalidation(snapshot.case_id, job.data)
  return job
}
